// extracted by mini-css-extract-plugin
export default {"h":"style_h__wjJiw","h2":"style_h2__9x8RR","p2":"style_p2__evaxW","h3":"style_h3__K0HlG"};